import { createAsyncTypes } from 'utils/ActionCreator'

const BASE_TYPE = 'EmailEncryption/Settings'

export const FETCH_SETTINGS_ASYNC = createAsyncTypes('FETCH_SETTINGS', BASE_TYPE)
export const FETCH_KILLSWITCH_ASYNC = createAsyncTypes('FETCH_KILLSWITCH', BASE_TYPE)
export const UPDATE_STATUS_ASYNC = createAsyncTypes('UPDATE_STATUS', BASE_TYPE)
export const UPDATE_SILENT_MODE_ASYNC = createAsyncTypes('UPDATE_SILENT_MODE', BASE_TYPE)
export const SAVE_SETTINGS_ASYNC = createAsyncTypes('SAVE_SETTINGS', BASE_TYPE)
export const UPDATE_KILLSWITCH_ASYNC = createAsyncTypes('UPDATE_KILLSWITCH', BASE_TYPE)
export const FETCH_ORIGINAL_SUBJECT_ASYNC = createAsyncTypes('FETCH_ORIGINAL_SUBJECT', BASE_TYPE)
export const UPDATE_ORIGINAL_SUBJECT_ASYNC = createAsyncTypes('UPDATE_ORIGINAL_SUBJECT', BASE_TYPE)
